// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#518fc8',
        secondary: '#518fc8',
        accent: '#0d6297',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
    //
  },
});
